module.exports = __webpack_public_path__ + "img/icon2.3a31eb81.png";